import { render, staticRenderFns } from "./MainVisual.vue?vue&type=template&id=31e1566b&"
import script from "./MainVisual.vue?vue&type=script&lang=js&"
export * from "./MainVisual.vue?vue&type=script&lang=js&"
import style0 from "./MainVisual.vue?vue&type=style&index=0&id=31e1566b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports